<template>
  <v-card :loading="!currentUser">
    <v-card-title>
      {{ $t("user.bookings.offers.title") }}
    </v-card-title>

    <v-card-text v-if="currentUser && offers.length">
      <Offer :booking="booking" v-for="booking in offers" :key="booking.id" class="mb-4" />
    </v-card-text>

    <v-card-text v-if="currentUser && !offers.length">
      {{ $t("user.bookings.offers.empty") }}
    </v-card-text>
  </v-card>
</template>

<script>
import { filter, propEq } from "ramda";
import Offer from "./Offer.vue";
import BookingsQuery from "@/gql/queries/BookingsQuery.gql";

export default {
  components: {
    Offer,
  },

  data() {
    return {
      currentUser: null,
    };
  },

  apollo: {
    currentUser: {
      query: BookingsQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  computed: {
    offers() {
      return filter(propEq("state", "OFFERED"), this.currentUser.bookings);
    },
  },
};
</script>
